import React, { useEffect, useRef, useState } from "react";
import { get } from "lodash";
import { Tooltip } from "antd";
import "./WordOverflowTooltip.scss";

const WordOverflowTooltip = (props: { text: any; }) => {
  const ref = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const title = props.text;

  useEffect(() => {
    console.log("WordOverflowTooltip.useEffect");
    if (
      get(ref, "current.clientWidth", 0) < get(ref, "current.scrollWidth", 0)
    ) {
      setShowTooltip(true);
    }
  }, []);

  return showTooltip ? (
    <Tooltip title={title} >
      <div ref={ref} className="ui-word-overflow-tooltip" >
        {title}
      </div>
    </Tooltip>
  ) : (
    <div ref={ref} className="ui-word-overflow-tooltip">
      {title}
    </div>
  );
};

export default WordOverflowTooltip;
